<template>
  <EditDepotSingleProduct
    :open="showDrawer"
    :close="handleShowDrawer"
    :productObject="activeProduct"
    :callEndPoints="callEndPoints"
  />
  <div v-if="products.length > 0">
    <div class="carousel">
      <div class="flex justify-end my-4 gap-x-4">
        <FlexWrapper class="items-center gap-x-4" v-if="products.length > 1">
          <button @click="prev" class="cursor-pointer">
            <img src="@/assets/svg/arrowLeft.svg" class="w-7" />
          </button>
          <button @click="next" class="cursor-pointer">
            <img src="@/assets/svg/arrowRight.svg" class="w-8" />
          </button>
        </FlexWrapper>
      </div>
      <div
        class="carousel-container"
        :class="products.length === 1 ? 'lg:justify-start justify-center' : ''"
      >
        <div
          :style="{ transform: `translateX(-${currentIndex * itemWidth}px)` }"
          class="carousel-items"
        >
          <!-- Render your carousel items here -->
          <div
            v-for="(item, index) in products"
            :key="index"
            class="rounded-lg carousel-item"
          >
            <div class="w-[90%] mx-auto py-2">
              <div
                class="flex items-center justify-between pb-2 border-b border-grey100"
              >
                <div class="flex items-center text-sm gap-x-1">
                  <img src="@/assets/svg/oil.svg" />

                  <p>
                    {{ item.depotProductName }}
                    <span class="ml-1">
                      <StatusTag
                        :type="
                          item.priceStatus?.toLowerCase() == 'price active'
                        "
                      />
                      <StatusTag
                        type="stopSale"
                        v-if="!item.isSelling"
                        class=""
                      />
                    </span>
                  </p>
                </div>

                <div class="relative">
                  <div
                    v-if="activeIndex === index"
                    class="absolute z-30 w-32 p-4 py-3 bg-white border rounded-lg top-3 right-3"
                  >
                    <p @click="handleShowDrawer(item)" class="cursor-pointer">
                      Edit
                    </p>
                    <button
                      :disabled="deleteClicked"
                      @click="handleDeleteProduct(item)"
                      class="my-1 cursor-pointer text-borderRed"
                    >
                      {{ deleteClicked ? "Deleting..." : "Delete" }}
                    </button>
                    <p
                      @click="() => openStopSaleModal(item.id)"
                      class="cursor-pointer"
                    >
                      {{ item.isSelling ? "Stop sale" : "Start sale" }}
                    </p>
                  </div>
                  <img
                    class="cursor-pointer"
                    @click="handleShowEdit(index)"
                    src="@/assets/svg/breadcrum.svg"
                  />
                </div>
              </div>

              <div class="my-4 text-center h-28">
                <ProductDonutChart :product="item" />
              </div>

              <div class="text-xs">
                <div class="flex items-center justify-between">
                  <p class="font-medium text-grey500">MAX VOL:</p>
                  <p class="font-semibold text-grey600">
                    {{ formatNumber(item.maxCapacity)
                    }}{{ item.measuringUnitSymbol }}
                  </p>
                  <!-- <p class="font-semibold text-grey600">560k.<sup>00</sup></p> -->
                </div>

                <div class="flex items-center justify-between my-3">
                  <p class="font-medium text-grey500">LAST PRICE:</p>

                  <p class="font-semibold text-grey600">
                    {{
                      item.lastActivePrice
                        ? `${amountFormat(item.lastActivePrice)}/${
                            item.measuringUnitSymbol
                          }`
                        : "---"
                    }}
                  </p>
                </div>

                <div class="flex items-center justify-between my-3">
                  <p class="font-medium text-grey500">CURRENT VOL:</p>

                  <!-- <p class="font-semibold text-grey600">560k.<sup>00</sup></p> -->
                  <p class="font-semibold text-grey600">
                    {{ formatNumber(item.currentQuantity)
                    }}{{ item.measuringUnitSymbol }}
                  </p>
                </div>

                <div class="flex items-center justify-between my-3">
                  <p class="font-medium text-grey500">CURRENT PRICE:</p>

                  <p class="font-semibold text-grey600">
                    {{ amountFormat(item.price) }}/{{
                      item.measuringUnitSymbol
                    }}
                  </p>
                </div>

                <div class="flex items-center justify-between py-2 border-t">
                  <p class="font-medium text-grey500">Last Active:</p>

                  <p class="font-semibold text-grey600">
                    {{
                      item.lastPriceDate
                        ? formatDate(item.lastPriceDate)
                        : "---"
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <h2 class="my-20 text-sm font-semibold text-center">
      Depot has no product,
      <span class="cursor-pointer text-green100" @click="openMapProductDrawer"
        >add product</span
      >
    </h2>
  </div>

  <!-- Stop sale confirmation modal -->
  <ConfirmModal
    :close="closeStopSaleConfirm"
    desc="Are you sure you want to make this change?"
    :isOpen="isStopSaleModalOpen"
    :handleYes="toggleProductStatus"
    :loading="loadingStopSale"
  />
  <!--  -->
</template>

<script>
//utils
import { formatNumber, amountFormat, formatDate } from "@/utils/formatter";

//components

import ConfirmModal from "@/components/UI/Confirmation/index.vue";
import ProductDonutChart from "./Chart/ProductDonutChart.vue";
import FlexWrapper from "@/components/UI/Wrappers/FlexWrapper.vue";

import depotService from "@/services/depot-service.js";
import EditDepotSingleProduct from "@/components/pages/Depot/EditDepotSingleProduct.vue";
import { useToast } from "vue-toastification";
import StatusTag from "@/components/UI/Tags/IsSellingTag.vue";

export default {
  name: "ProductCarousel",
  props: ["products", "openMapProductDrawer", "callEndPoints"],
  components: {
    FlexWrapper,
    ProductDonutChart,
    EditDepotSingleProduct,
    StatusTag,

    ConfirmModal,
  },
  data() {
    return {
      formatNumber,
      amountFormat,
      formatDate,
      currentIndex: 0,
      activeIndex: -1,
      itemWidth: 273, // Adjust this value based on your item width
      showDrawer: false,
      activeProduct: {},
      toast: useToast(),
      deleteClicked: false,
      isStopSaleModalOpen: false,
      loadingStopSale: false,
      productId: null,
    };
  },
  mounted() {
    // console.log(this.products, "dklsd");
  },
  methods: {
    //Requests
    async toggleProductStatus() {
      this.loadingStopSale = true;
      try {
        const result = await depotService.toggleProductStatus(this.productId);
        if (result) {
          this.toast.success("Product sales stopped succesfully");
          this.callEndPoints();
          this.closeStopSaleConfirm();
        }
      } catch (err) {
      } finally {
        this.loadingStopSale = false;
      }
    },
    openStopSaleModal(data) {
      this.productId = data;
      this.isStopSaleModalOpen = true;
    },
    closeStopSaleConfirm() {
      this.isStopSaleModalOpen = false;
    },
    handleShowDrawer(product) {
      this.activeProduct = product;
      this.showDrawer = !this.showDrawer;
    },
    prev() {
      this.currentIndex = Math.max(0, this.currentIndex - 1);
    },
    next() {
      // console.log("djksd");
      this.currentIndex = Math.min(
        this.products.length - 1,
        this.currentIndex + 1
      );
    },
    async handleDeleteProduct(prod) {
      this.deleteClicked = true;
      try {
        const result = await depotService.deleteProductSale(prod.id);
        this.callEndPoints();
        this.toast.success("Product Deleted", { timeout: 3000 });
      } catch (e) {
        console.log(e);
      } finally {
        this.deleteClicked = false;
      }
      // Get Some sort of id to use for it.
    },
    handleShowEdit(ind_) {
      if (ind_ === this.activeIndex) {
        this.activeIndex = -1;
        return;
      }
      this.activeIndex = ind_;
    },
  },
};
</script>

<style scoped>
.carousel {
  position: relative;
  width: 100%;
  padding-bottom: 20px;
  overflow-x: auto;
}

/* Webkit-based browsers */
.carousel::-webkit-scrollbar {
  width: 12px; /* Set the width of the scrollbar */
  height: 3px;
}

/* Track */
.carousel::-webkit-scrollbar-track {
  background: white; /* Change the color of the scrollbar track */
}

/* Handle */
.carousel::-webkit-scrollbar-thumb {
  background: black; /* Change the color of the scrollbar handle */
  border-radius: 6px; /* Adjust the border-radius */
}

/* Handle on hover */
.carousel::-webkit-scrollbar-thumb:hover {
  background: #555; /* Change the color on hover */
}

.carousel-container {
  display: flex;
}

.carousel-items {
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-item {
  width: 270px; /* Adjust this value to match your item width */
  /* height: 100px; */
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ddd;
  margin: 0 10px;
}

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  padding: 10px 20px;
  background: #333;
  color: #fff;
  cursor: pointer;
}

.prev {
  left: 0;
}

.next {
  right: 0;
}
</style>
